import { Component, ViewChild, ChangeDetectorRef } from "@angular/core";
import { ListWindow, PageService, TabComponent } from "@xo/client-common";
import { Type1StringTable } from "./type1String.table";

@Component({
  selector: "spec-app-type1-string-list-window",
  templateUrl: "./type1String.list.html",
  styleUrls: ["./type1String.list.scss"]
})
export class Type1StringListWindowComponent extends ListWindow {

  @ViewChild("table", { static: false }) table: Type1StringTable;

  clickHandler: Function;

  constructor(changeDetectorRef: ChangeDetectorRef, private tab: TabComponent, public pageService: PageService) {
    super(changeDetectorRef);
  }

  init(filters?) {
    this.clickHandler = this.pageService.createOpenObject(
      "SpecApp/Type1StringPage",
      this.tab.system,
      (object) => `Type1String at ID:${object ? object.id : null}`,
      () => ({})
    );
    super.init(filters, this.table);
  }

  reload() {
    console.log("Type1StringList reload");
    super.reload();
    this.table.refreshList();
  }
}
